export default __webpack_public_path__ + "static/media/avatar2.858529d5.png";